import { gkApi } from './index';

const articleApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listArticles: builder.query({
      query: () => ({
        url: '/article/',
        method: 'get',
        params: { limit: 500 },
      }),
    }),
    listCrewArticles: builder.query({
      query: () => ({
        url: '/article/crew/',
        method: 'get',
        params: { limit: 500 },
      }),
    }),
  }),
});

export const { useListArticlesQuery, useListCrewArticlesQuery } = articleApi;
